const common = {
  theme: "Tema",
  themeLight: "Claro",
  themeDark: "Escuro",
  actions: {
    add: "Adicionar",
    edit: "Editar",
    delete: "Excluir",
    save: "Salvar",
    saving: "Salvando...",
    cancel: "Cancelar",
    close: "Fechar",
    confirm: "Confirmar",
    back: "Voltar",
    next: "Próximo",
    finish: "Finalizar",
    reset: "Restaurar",
    search: "Buscar",
    filter: "Filtrar",
    sort: "Ordenar",
    refresh: "Atualizar",
    retry: "Tentar novamente",
    view: "Visualizar",
    download: "Baixar",
    upload: "Enviar",
    import: "Importar",
    export: "Exportar",
    preview: "Visualizar",
    copy: "Copiar",
    clear: "Limpar",
    submit: "Enviar"
  },
  generating: "Gerando...",
  of: "de",
  save: "Salvar",
  saving: "Salvando...",
  sending: "Enviando...",
  syncing: "Sincronizando...",
  close: "Fechar",
  cancel: "Cancelar",
  create: "Criar",
  done: "Concluído",
  delete: "Excluir",
  coming_soon: "Em breve...",
  id: "ID",
  insertedAt: "Inserido em",
  metadata: "Metadados",
  version: "Versão",
  actionButtons: "Ações",
  basicInfo: "Informações Básicas",
  content: "Conteúdo",
  knowledgeId: "ID da Base de Conhecimento",
  noResults: "Nenhum resultado encontrado",
  none: "Nenhum",
  error: "Erro",
  success: "Sucesso",
  warning: "Aviso",
  info: "Informação",
  loading: "Carregando...",
  deleting: "Excluindo...",
  noData: "Nenhum dado disponível",
  selectOption: "Selecione uma opção",
  noOptionsAvailable: "Nenhuma opção disponível",
  pageNotFound: "Página não encontrada",
  pageNotFoundDescription: "A página que você está procurando não existe ou foi movida.",
  goBack: "Voltar",
  goHome: "Ir para o início",
  noChanges: "Nenhuma alteração",
  noChangesDescription: "Não foram feitas alterações para salvar.",
  categories: {
    Files: "Arquivos",
    Triggers: "Gatilhos",
    Embeddings: "Embeddings",
    API: "APIs",
    Databases: "Bancos de Dados",
    "Knowledge Base": "Base de Conhecimento"
  },
  pages: {
    knowledge: {
      title: "Conhecimento",
      description: "O segundo cérebro do seu workspace",
      tabs: {
        imports: "Importações",
        transformation: "Transformação",
        database: "Banco de Dados",
        storage: "Armazenamento",
        pipelines: "Pipelines",
        flows: "Fluxos"
      },
      imports: {
        title: "Importações",
        description: "Gerencie suas importações",
        addButton: "Importar",
        search: "Buscar importações...",
        searchTools: "Buscar ferramentas...",
        selectTool: "Selecione uma ferramenta",
        empty: {
          title: "Nenhuma importação encontrada",
          description: "Adicione uma nova importação para começar"
        },
        form: {
          title: "Nova Importação",
          description: "Configure sua importação",
          submit: "Importar"
        },
        status: {
          active: "Ativo",
          inactive: "Inativo",
          pending: "Pendente",
          failed: "Falha",
          success: "Sucesso",
          error: "Erro",
          processing: "Processando"
        },
        messages: {
          success: "Importação realizada com sucesso",
          error: "Erro ao realizar importação",
          deleted: "Importação excluída com sucesso",
          fetchError: "Erro ao carregar importações"
        }
      },
      transformation: {
        nodes: "Componentes",
        nodeTypes: {
          input: "Entrada",
          process: "Processo",
          output: "Saída"
        }
      },
      database: {
        fields: {
          id: "ID",
          content: "Conteúdo",
          reference: "Referência",
          createdAt: "Criado em",
          updatedAt: "Atualizado em",
          filterBy: "Filtrar por",
        }
      },
      storage: {
        title: "Armazenamento",
        description: "Armazene e gerencie seus dados de diferentes fontes",
        updatedAt: "Atualizado em"
      },
      noActiveKnowledgeBase: "Nenhuma base de conhecimento ativa. Selecione uma base de conhecimento para visualizar os embeddings."
    }
  },
  workflow: {
    webhook: {
      waiting: 'Aguardando evento no Webhook',
    },
    error: {
      no_webhook_trigger: 'Webhook Trigger não encontrado',
      no_webhook_trigger_desc: 'É necessário ter um node do tipo webhook_trigger no workflow para realizar o teste.',
      webhook_registration_failed: 'Falha ao registrar webhook no servidor',
      test_failed: 'Falha ao testar workflow',
      server_error: 'Erro no servidor',
      unknown: 'Ocorreu um erro inesperado',
      connection_failed: 'Falha na conexão com o servidor de eventos',
      timeout: 'Tempo limite de espera excedido (5 minutos)',
      invalid_response: 'Resposta inválida do servidor'
    }
  },
  messages: {
    deleteSuccess: "Item excluído com sucesso",
    deleteSuccessDescription: "O item foi excluído com sucesso.",
    deleteError: "Erro ao excluir o item. Por favor, tente novamente.",
    deleteConfirmationTitle: "Excluir item",
    deleteConfirmationDescription: "Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.",
    loading: "Carregando...",
    error: "Erro",
    errorDescription: "Ocorreu um erro. Por favor, tente novamente.",
    success: "Sucesso",
    successDescription: "Operação realizada com sucesso.",
    warning: "Atenção",
    info: "Informação"
  },
  notifications: {
    saveSuccess: "Salvo com sucesso",
    saveError: "Erro ao salvar",
    deleteSuccess: "Excluído com sucesso",
    deleteError: "Erro ao excluir",
  },
  errors: {
    notAuthenticated: "Usuário não autenticado",
    organizationNotFound: "Organização não encontrada",
  },
  attention: "Atenção",
  errorLoadingData: "Erro ao carregar dados",
  required: "Campo obrigatório",
  select: "Selecione",
  copied: "Copiado!",
  copy: "Copiar",
  documentation: "Documentação",
  help_center: "Central de Ajuda",
  help: {
    userManual: "Manual do Usuário",
    guidedTour: "Tour Guiado"
  },
  status: {
    success: "Sucesso",
    error: "Erro",
    warning: "Atenção",
    info: "Informação"
  },
  pagination: {
    showing: "Exibindo {{start}} a {{end}} de {{total}} itens",
    itemsPerPage: "Itens por página",
    showing_items: "Mostrando {{start}} - {{end}} de {{total}} itens",
    no_results: "Nenhum resultado encontrado",
    page_of_total: "Página {{current}} de {{total}}",
    pageOfTotal: "Página {{current}} de {{total}}"
  },
  logs: {
    dateColumnTypeDetected: "Tipo de coluna de data detectado",
    textColumnTypeDetected: "Tipo de coluna de texto detectado",
    mixedColumnTypesDetected: "Tipos de colunas mistos detectados",
    noColumnsSelected: "Nenhuma coluna selecionada",
    clearingSelectedColumnType: "Limpando tipo de coluna selecionado",
    columnSelected: "Coluna",
    selected: "selecionada",
    deselected: "desselecionada",
    type: "tipo"
  },
  optional: "opcional",
  characters: "caracteres",
  all: "Todos",
  workspaces: {
    addWorkspace: "Workspace",
    selectWorkspace: "Selecione um Workspace",
    selectWorkspaceDescription: "Para acessar os agentes e recursos, selecione um workspace no menu superior.",
    emptyState: {
      title: "Tudo começa com um workspace",
      description: "Reúna seu time, projetos e agents de IA em um só lugar. Crie seu primeiro workspace para gerenciar fluxos de trabalho, base de conhecimento e tudo que seu produto precisa.",
      adminAction: "Crie seu primeiro Workspace para desbloquear os recursos da plataforma.",
      userMessage: "Por favor, entre em contato com seu administrador para criar um Workspace e começar.",
      noOrganizationWarning: "Você precisa concluir a configuração da organização antes de criar um Workspace. Por favor, finalize o processo de onboarding primeiro."
    }
  },
  poweredBy: "Desenvolvido por",
  companyName: "Programmers",
  trademark: "®"
} as const;

export default common;
